import { render, staticRenderFns } from "./systemConfigList.vue?vue&type=template&id=5c251a13&scoped=true"
import script from "./systemConfigList.vue?vue&type=script&lang=js"
export * from "./systemConfigList.vue?vue&type=script&lang=js"
import style0 from "./systemConfigList.vue?vue&type=style&index=0&id=5c251a13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c251a13",
  null
  
)

export default component.exports